import { render, staticRenderFns } from "./FilesUpload.vue?vue&type=template&id=374f539a&scoped=true&"
import script from "./FilesUpload.vue?vue&type=script&lang=js&"
export * from "./FilesUpload.vue?vue&type=script&lang=js&"
import style0 from "./FilesUpload.vue?vue&type=style&index=0&id=374f539a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374f539a",
  null
  
)

export default component.exports